<template>
  <div class="card card-table flex-fill">
    <div class="card-header">
      <h3 class="card-title mb-0">Scrape Terakhir</h3>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table custom-table mb-0">
          <thead>
            <tr>
              <th>Judul</th>
              <th class="text-center">Marketplace</th>
              <th>Keyword</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="loading">
              <tr>
                <td colspan="3">
                  <Skeleton :count="1" />
                </td>
              </tr>
            </template>
            <template v-else>
            <template v-if="rows.length > 0">
              <template v-if="rows.length">
                <tr v-for="(row, index) in rows" :key="index">
                  <td>{{ row.title }}</td>
                  <td class="d-flex flex__gap-10 flex-wrap justify-content-center text-wrap text-center" :ref="'marketplace-' + row.id">
                    <Skeleton circle height="50px" width="50px" :count="1" />
                  </td>
                  <td class="text-wrap" :ref="'keywords-' + row.id">
                    <Skeleton :count="1" />
                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <td colspan="3" class="text-center">Tidak ada data yang tersedia</td>
              </tr>
            </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card-footer">
      <router-link :to="{ name: 'monitoring_scrape_list' }"
        >Lihat Semua Scrape</router-link
      >
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { marketplaceIcon } from "@/utils/helper"

export default {
  data() {
    return {
      licenseArr: [],
      licenseArrLoading: false,
      taskLoading: false,
      taskTotalRecords: 0,
      taskRows: [],
      taskParams: {
        columnFilters: {
          license_id: "",
          agent_id: "",
          is_resolved: "0"
        },
        page: 1,
        perPage: 20 // perPage
      },
      loading: false,
      currentPage: 1,
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 10
      }
    };
  },
  components: {
    Skeleton
  },
  created() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("monitoring/listScraping", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          this.loading = false;

          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let scheduleId = row.id;
              this.$store
                .dispatch("monitoring/getMarketplaceByScheduleId", scheduleId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;

                  resData.forEach((rowMarketplace, idxMarketplace) => {
                    if (idxMarketplace == 0) {
                      this.$refs[
                        "marketplace-" + scheduleId
                      ][0].innerHTML = this.marketplaceIcon(
                        rowMarketplace.mp_master_id
                      );
                    } else {
                      this.$refs[
                        "marketplace-" + scheduleId
                      ][0].innerHTML += this.marketplaceIcon(
                        rowMarketplace.mp_master_id
                      );
                    }
                  });
                });
              this.$store
                .dispatch("monitoring/getKeywordsByScheduleId", scheduleId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  resData.forEach((rowKeywords, idxKeywords) => {
                    if (idxKeywords == 0) {
                      this.$refs["keywords-" + scheduleId][0].innerHTML =
                        rowKeywords.name;
                    } else {
                      this.$refs["keywords-" + scheduleId][0].innerHTML +=
                        ", " + rowKeywords.name;
                    }
                  });
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    marketplaceIcon(value){
        return marketplaceIcon(value)
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeedashboard"
};
</script>

<style scoped>
.flex__gap-10 {
  gap: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/components/lastScrape.vue